import ConnectionSuccesful, { Buttons } from "./connectionSuccessful";
import { type } from "./dataMapping";

export default function IntegrationConnectionSuccesful({
  onSubmit,
  onBack,
  parameters,
  type,
}: {
  onSubmit: React.Dispatch<React.SetStateAction<string>>;
  onBack: React.Dispatch<React.SetStateAction<string>>;
  parameters: string[];
  type: type;
}) {
  return (
    <div className="mx-auto w-[379px] h-[326px] justify-between flex flex-col gap-[32px]">
      <ConnectionSuccesful type={type} parameters={parameters} />
      <Buttons onSubmit={onSubmit} onBack={onBack} type={type} />
    </div>
  );
}
